var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTransmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 140,
    viewBox: "0 0 182 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.9414,
    y: 0.5,
    width: 80.6605,
    height: 139,
    rx: 8.5,
    fill: "black",
    fillOpacity: 0.22,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 27.265,
    transform: "matrix(0.704767 -0.709439 0.704767 0.709439 121.182 51.6017)",
    fill: "#00C6C6",
    fillOpacity: 0.2,
    stroke: "#1E273B",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.455 72.0087L161.728 92.4158",
    stroke: "#1E273B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9463,
    y: 103.984,
    width: 74.8613,
    height: 14.4162,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2012,
    y: 105.95,
    width: 11.7174,
    height: 10.4845,
    rx: 2,
    fill: "#FC7292"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8711,
    y: 109.882,
    width: 26.0387,
    height: 1.31057,
    rx: 0.655283,
    fill: "#807376"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8711,
    y: 111.848,
    width: 39.0581,
    height: 1.31057,
    rx: 0.655283,
    fill: "#1E273B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 79.9337,
    width: 61.8419,
    height: 14.4162,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25488,
    y: 81.8995,
    width: 11.7174,
    height: 10.4845,
    rx: 2,
    fill: "#FC7292"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 85.8312,
    width: 26.0387,
    height: 1.31057,
    rx: 0.655283,
    fill: "#807376"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 87.7971,
    width: 39.0581,
    height: 1.31057,
    rx: 0.655283,
    fill: "#1E273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTransmission);
export default __webpack_public_path__ + "static/media/wait-transmission.5a4a93971ccf0a46fd6a2f3bc37f7750.svg";
export { ForwardRef as ReactComponent };